// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3eTnO","footer":"ModalUpdate_footer__2rVPD"};